import { contestActions } from '../ActionTypes';
import { updateState } from '../../middlewares/utils';

const initialFormData = {
  Id: '0',
  Title: '',
  Description: '',
  FAQ: '',
  FeaturedImageURL: '',
  Rules: '',
  OrderNumber: '',
  SlugURL: ''
};

const defaultState = {
  contestList: [],
  tableLoading: false,
  form: initialFormData,
  formLoading: false,
  formError: null,
  deleteId: null
};


export default (state = defaultState, actions) => {
  switch (actions.type) {
    case contestActions.CONTEST_FETCH_START:
      return updateState(state, { tableLoading: true });
    case contestActions.CONTEST_FETCH_SUCCESS:
      return updateState(state, { tableLoading: false, contestList: actions.payload });
    case contestActions.CONTEST_FETCH_ERROR:
      return updateState(state, { tableLoading: false, ...actions.payload });
    case contestActions.CONTEST_SAVE_START:
      return updateState(state, { formLoading: true, formError: null, form: initialFormData });
    case contestActions.CONTEST_SAVE_SUCCESS:
      return updateState(state, { formLoading: false, form: initialFormData });
    case contestActions.CONTEST_SAVE_FAILED:
      return updateState(state, { formLoading: false, ...actions.payload });
    case contestActions.CONTEST_SET_FORM:
      return updateState(state, { ...actions.payload, formError: null });
    case contestActions.CONTEST_RESET_FORM:
      return updateState(state, { form: initialFormData });
    default:
      return state;
  }
};
